import { useEffect, useRef, useState } from "react"
import useAuth from 'hooks/UseAuth';

import { toast } from 'react-toastify';
import {
  Calendar, Select
 } from 'antd';
 import { ConfigProvider as CalendarWrapper } from 'antd';
import { CalendarMode } from "antd/lib/calendar/generateCalendar";
import pt_BR from 'antd/lib/locale/pt_BR';
import 'antd/dist/antd.css';
import moment, { Moment } from 'moment';
import 'moment/locale/pt-br';

import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"
import { AgendaDetailsModal } from 'shared/components/molecules/AgendaDetailsModal/AgendaDetailsModal';

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import { ReactComponent as HalfTabs } from 'assets/icons/half-tabs-icon.svg'

import WilliamsPic from 'assets/img/historic/williams-pic.png'

import { parseDate } from 'utils/parseDate';
import { parseMonthRange } from 'utils/ensureMonthRange';

import api from 'services/api';

import {
  IAppointmentData, IAppointments
} from './interfaces';

import {
  ClockIcon, Container, Content, ReturnButton, SectionAgenda
} from "./_agenda"
import { HistoricDetailsModal } from "shared/components/molecules/HistoricDetailsModal/HistoricDetailsModal";
import { ProductPhotoModal } from "shared/components/molecules/ProductPhotoModal/ProductPhotoModal";

interface IHeaderRenderProps {
  value: Moment,
  type: string,
  onChange(date: Moment): void,
  onTypeChange(type: CalendarMode): void
}

const parseCurrency = (value: string) => {
  const number = Number(value) / 100;

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(number);
}

export const Agenda = () => {
  moment.locale('pt-br', {
    weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  })

  const [firstDay, lastDay] = parseMonthRange(new Date())

  const { user } = useAuth();
  const providerId = user?.provider?.id;

  const filterRef = useRef(null)

  const [initialDay, setInitialDay] = useState(moment(firstDay).format('YYYY-MM-DD'))
  const [finalDay, setFinalDay] = useState(moment(lastDay).format('YYYY-MM-DD'))

  const [currentMonth, setCurrentMonth] = useState(moment().format('MMMM'));
  const [currentYear, setCurrentYear] = useState(moment().format('YYYY'));

  const [monthAppointments, setMonthAppointments] = useState([] as Array<IAppointments>);

  const [showFilter, setShowFilter] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [selectedCode, setSelectedCode] = useState<undefined | number>();
  const [modalContent, setModalContent] = useState({} as IAppointmentData);

  const [showProductPhotoModal, setShowProductPhotoModal] = useState(false);
  const [productPhotoUrl, setProductPhotoUrl] = useState('');

  function handleShowModal(appointment: IAppointments) {
    /* setModalContent({
      code: appointment?.code,
      service_name: appointment?.service_type?.name,
      provider_name: appointment?.provider?.user?.individual_person?.name,
      provider_avatar: appointment?.provider?.user?.avatar_url,
      rating: appointment?.provider?.average_rating,
      date: appointment?.service_solicitation?.date,
      address_id: appointment?.service_solicitation?.address_id,
      status_id: appointment?.service_solicitation?.status_id,
      service_type_id: appointment?.service_solicitation?.service_type_id
    }) */

    setSelectedCode(Number(appointment?.code || 0))

    setShowModal(true)
  }

  function onPanelChange(value: Moment) {
    setCurrentMonth(value.format('MMMM'));
    setCurrentYear(value.format('YYYY'));

    const [firstDay, lastDay] = parseMonthRange(new Date(value.format('YYYY-MM-DD')));

    setInitialDay(moment(firstDay).format('YYYY-MM-DD'))
    setFinalDay(moment(lastDay).format('YYYY-MM-DD'))
  }

  function dateCellRender(value: Moment) {
    const eventDates = monthAppointments.map(appointments => moment(appointments.service_solicitation.date).format('YYYY-MM-DD'))

    const currentDate = value.format('YYYY-MM-DD')
    const currentWeekDay = value.format('dddd').slice(0, 3)

    const listData = [];

    if(eventDates.includes(currentDate)){
      listData.push(currentWeekDay)
    }

    return (
      <>
        {listData.map(day => (
            <li className="agenda-section__cell-inner-monthday-container">
              <p className="agenda-section__cell-inner-monthday">
                {day}
              </p>
            </li>
          ))}
      </>
    );
  }

  function HeaderRender({
    value, onChange, onTypeChange
  }: IHeaderRenderProps) {
    const start = 0;
    const end = 12;
    const monthOptions = [];

    const current = value.clone();
    const localeData = value.localeData();
    const months = [];

    for (let i = 0; i < 12; i++) {
      current.month(i);
      months.push(localeData.monthsShort(current));
    }

    for (let index = start; index < end; index++) {
      monthOptions.push(
        <Select.Option
          key={`${index}`}
          value={`${index}`}
          className="month-item"
        >
          {months[index]}
        </Select.Option>,
      );
    }

    const month = value.month();
    const year = value.year();
    const options = [];

    for (let i = year - 10; i < year + 10; i += 1) {
      options.push(
        <Select.Option key={i} value={i} className="year-item">
          {i}
        </Select.Option>,
      );
    }

    return (
      <div className="agenda-section__calendar-header">
        <button
          type="button"
          className="agenda-section__calendar-header-button"
          onClick={() => setShowFilter(prevState => !prevState)}
        >
          <HalfTabs />
        </button>
        {showFilter && (
          <div
            ref={filterRef}
            className="agenda-section__calendar-header__select-container"
          >
            <Select
              size="small"
              dropdownMatchSelectWidth={false}
              className="my-year-select"
              onChange={newYear => {
                const now = value.clone().year(newYear as any);

                onChange(now);
              }}
              value={String(year)}
            >
              {options}
            </Select>
            <Select
              size="small"
              dropdownMatchSelectWidth={false}
              value={String(month)}
              onChange={selectedMonth => {
                const newValue = value.clone();

                newValue.month(parseInt(selectedMonth, 10));

                onChange(newValue);
              }}
            >
              {monthOptions}
            </Select>
          </div>
        )}
        <h1 className="agenda-section__calendar-date">
          {currentMonth}
          {' '}
          <strong className="agenda-section__calendar-date-strong">
            {currentYear}
          </strong>
        </h1>
      </div>
    );
  }

  const handleOpenPhotoModal = (url: string) => {
    setProductPhotoUrl(url)
    setShowProductPhotoModal(true)
  }

  const ensureAppointments = async () => {
    setMonthAppointments([] as Array<IAppointments>);

    try {
      // const response: any = await api.get(`/appointments?initial_date=${initialDay}&final_date=${finalDay}&provider_id=${providerId}&canceled=false`)
      const response: any = await api.get(`/appointments?initial_date=2021-01-01&final_date=2070-12-31`)

      setMonthAppointments(response?.data?.service_appointments)
    } catch (error: any) {
      toast.error(error?.response?.data?.message)
    }
  }

  useEffect(() => {
    ensureAppointments()
  }, [currentMonth])

  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <ReturnButton to="/perfil">
          <LeftArrow
            className="faq__content-icon"
          />
        </ReturnButton>

        <SectionAgenda>
          <article
            className="agenda-section__calendar-container"
          >
            <CalendarWrapper locale={pt_BR}>
              <Calendar
                fullscreen={false}
                onPanelChange={onPanelChange}
                dateCellRender={dateCellRender}
                headerRender={HeaderRender}
              />
            </CalendarWrapper>
          </article>

          {monthAppointments?.length > 0 && (
            <aside className="agenda-section__aside">
              {monthAppointments.map(appointment => (
                <article
                  key={appointment.id}
                  className="agenda-section__aside-article"
                >
                  <div className="agenda-section__aside-article-wrapper">
                    <button
                      type="button"
                      className="agenda-section__aside-article__product-photo-button"
                      onClick={() => handleOpenPhotoModal(appointment.image_url)}
                    >
                      <img src={appointment.image_url} alt="" onError={
                        (event: any) => {
                          event.target.style = 'visibility: hidden;'
                        }
                      } className="agenda-section__aside-article__product-photo" />
                    </button>
                    {/* <ClockIcon /> */}
                    <div className="agenda-section__aside-article__content-wrapper">
                      <p className="agenda-section__aside-article__content-text">
                        Você recebeu um chamado de
                        serviços de
                        {' '}
                        <b className="agenda-section__aside-article__content-text-b">
                          {appointment?.service_type?.name}.
                        </b>
                      </p>
                      <time className="agenda-section__aside-article__content-time">
                        {parseDate(appointment?.service_solicitation?.date)}
                      </time>

                      <p className="agenda-section__aside-article__content-solicitation-info">
                        Valor do serviço: {parseCurrency(appointment?.service_solicitation?.price)}
                      </p>

                      <p className="agenda-section__aside-article__content-solicitation-info">
                        {appointment?.service_solicitation?.product_model}
                      </p>

                      <button
                        type="button"
                        className="agenda-section__aside-article__content-button"
                        onClick={() => handleShowModal(appointment)}
                      >
                        ver detalhes
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </aside>
          )}
        </SectionAgenda>
      </Content>
      {/* {showModal && (
        <AgendaDetailsModal
          toggleModal={setShowModal}
          appointment={modalContent}
        />
      )} */}
      {showModal && (
        <HistoricDetailsModal
          toggleModal={setShowModal}
          code={selectedCode}
        />
      )}
      {
        showProductPhotoModal && (
          <ProductPhotoModal
            toggleModal={setShowProductPhotoModal}
            url={productPhotoUrl}
          />
        )
      }
    </Container>
  )
}
